import React from 'react';
import s from './s.module.less';

interface RadioOptionProps {
    id: string;
    label: string;
    checked: boolean;
    onChange: (id: string) => void;
}

export default function RadioOption({ id, label, checked, onChange }: RadioOptionProps) {
    const handleChange = () => {
        onChange(id);
    };

    return (
        <div
            className={`${s.option} ${checked ? s.selected : ''}`}
            onClick={handleChange}
            role="radio"
            aria-checked={checked}
            tabIndex={0}
            onKeyDown={(e) => {
                if (e.key === ' ' || e.key === 'Enter') {
                    e.preventDefault();
                    handleChange();
                }
            }}
        >
            {/* <div className={`${s.radio} ${checked ? s.checked : ''}`}>
                {checked && (
                    <div className={s.radioInner} />
                )}
            </div> */}
            <span className={s.label}>
                {label}
            </span>
        </div>
    );
}
